import React, {useEffect, useMemo, useState} from 'react'
import moment from 'moment'
import ReactPaginate from 'react-paginate'
import {useDispatch, useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
// import AssignStaffPopup from './ProfilePageComponent/AssignStaffPopup'

import ChangeAssignedStaff from './modal/ChangeAssignedStaff'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'

import {
  deallocateStaff,
  getAllAssigneeUser,
  getAllStaffAssignedToUserList,
} from './UserProfileDetailSlice/UserProfileDetailSlice'
import {KTSVG, useDebounce} from '../../../../../_metronic/helpers'
import {getUserData} from '../../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import {
  getAccountManageList,
  getAllAccountManagerList,
  getAllSalesList,
  getSalesList,
} from '../UserListSlice/UserListSlice'
import NodataYet from '../../../../Components/NodataYet'

const AssignStaff = () => {
  const dispatch = useDispatch()
  const [assign, setAssign] = useState(false)

  const location = useLocation()
  const {userProp} = location.state || ({} as any)

  const userDataState = useSelector((state: any) => state?.ProfileData?.ProfileData?.user)
  const ProfileDetatileState = userProp?.user ? userProp.user : userDataState

  const assignedStaffToUserList = useSelector(getAllStaffAssignedToUserList)
  const [searchName, setSearchName] = useState('')

  const [checkList, setCheckList] = useState<any>([])
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [deallocate, setDeallocate] = useState({
    userId: ProfileDetatileState?._id,
    staffId: '',
  })
  const [page, setPage] = useState({
    page: 1,
    size: 10,
    search: '',
  })

  const [assignTo, setAssignTo] = useState({
    userId: ProfileDetatileState?._id,
    accountManagerId: '',
    salesId: '',
  })

  const debouncedSearchTerm = useDebounce(page?.search, 3000)
  // const debouncedSearchUser = useDebounce(searchName, 3000)
  const AssignStaff = useMemo(
    () => (
      <ChangeAssignedStaff
        list={assignTo}
        setAssign={setAssignTo}
        show={assign}
        handleClose={() => setAssign(false)}
        setSearchName={setSearchName}
      />
    ),
    [assign, assignTo]
  )
  useEffect(() => {
    dispatch(getAllAssigneeUser({userId: ProfileDetatileState?._id, ...page}))
  }, [debouncedSearchTerm, page.page, page.size])

  useEffect(() => {
    if (confirm == true) {
      dispatch(deallocateStaff(deallocate))
    }
    setConfirm(false)
  }, [confirm])

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={open}
        handleClose={() => setOpen(false)}
        checklist={() => setCheckList([])}
        Message={'Are you sure, you want to delete this staff?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )

  const handleDelete = (id: any) => {
    setOpen(true)
    if (ProfileDetatileState?.role == 'owner') {
      setDeallocate({...deallocate, staffId: id})
    }
    // else {
    //   setDeallocate({...deallocate, userId: id, staffId: ProfileDetatileState?._id})
    // }
  }

  useEffect(() => {
    dispatch(getAccountManageList())
    dispatch(getSalesList())
  }, [])

  useEffect(() => {
    setAssignTo({
      ...assignTo,
      accountManagerId: assignedStaffToUserList?.items?.filter(
        (key: any) => key?.role == 'accountManager'
      )?.[0]?._id,
      salesId: assignedStaffToUserList?.items?.filter(
        (key: any) => key?.role !== 'accountManager'
      )?.[0]?._id,
    })
  }, [assignedStaffToUserList?.items, assign])

  return (
    <>
      {confirmation}
      {AssignStaff}
      <div className={`sub-accountstable card`}>
        <div className='card'>
          <div className='card-body'>
            <div className='d-flex flex-wrap flex-sm-nowrap'>
              <div className='flex-grow-1'>
                <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                  <div className='d-flex flex-column'>
                    <div className='d-flex align-items-center mb-2'>
                      <a className='text-gray-900 text-hover-primary fs-2 fw-bolder me-1'>
                        Assigned Staff
                      </a>
                    </div>
                  </div>
                  <div className='d-flex mb-3'>
                    <button
                      className='btn btn-light-primary btn-sm me-2'
                      onClick={() => setAssign(true)}
                    >
                      Assign Staff
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {assignedStaffToUserList?.items?.length > 0 ? (
          <div className='card-body py-3'>
            <div className='table-responsive'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bolder text-muted'>
                    <th className='min-w-150px'>USER</th>

                    <th className='min-w-150px'>Assigne As</th>

                    <th className='min-w-150px'>CREATED ON</th>

                    <th className='min-w-100px '>ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {assignedStaffToUserList?.items?.map((data: any, i: number) => (
                    <tr key={i}>
                      <td>
                        <div className='d-flex align-items-center'>
                          <div
                            // onClick={() => navigate('/user-profile', {state: [data, 'user']})}
                            className='symbol symbol-45px me-5'
                          >
                            <span className='circle1'>{`${data?.firstName
                              ?.split('')[0]
                              ?.toUpperCase()}${
                              data?.lastName !== undefined && data?.lastName !== ''
                                ? data?.lastName?.split('')[0]
                                : ''
                            }`}</span>
                          </div>
                          <div className='d-flex justify-content-start flex-column'>
                            <a className='text-dark fw-bolder text-hover-primary fs-6'>
                              {`${data?.firstName} ${data?.lastName}`}
                            </a>
                            <span className='text-muted fw-bold text-muted d-block fs-7'>
                              {data?.email}
                            </span>
                          </div>
                        </div>
                      </td>
                      {ProfileDetatileState?.role === 'owner' && <td>{data?.role}</td>}
                      <td>
                        <span className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                          {moment(data?.createdAt).format('DD/MM/YYYY')}
                        </span>
                      </td>
                      {
                        <td>
                          <span
                            onClick={() => handleDelete(data?._id)}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                          >
                            <KTSVG
                              path='/media/icons/duotune/general/gen027.svg'
                              className='svg-icon-3'
                            />
                          </span>
                        </td>
                      }
                    </tr>
                  ))}
                </tbody>
              </table>
              {ProfileDetatileState?.role !== 'owner' && (
                <div className='abcd '>
                  {/* <select
                  //  onChange={(e: any) => setPage({...page, size: e.target.value})}
                  >
                    <option>10</option>
                    <option>20</option>
                    <option>50</option>
                    <option>ALl</option>
                  </select> */}
                  <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={assignedStaffToUserList?.totalPages}
                    onPageChange={(e) => setPage({...page, page: e.selected + 1})}
                    containerClassName={'pagiantion'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              )}
            </div>
          </div>
        ) : (
          <NodataYet />
        )}
      </div>
    </>
  )
}

export default AssignStaff
